import { getActuralApi } from './utils';

export const reportChartList = getActuralApi('/media/v1/industry/report_chart/list');
export const originalReportInfo = getActuralApi('/media/v1/industry/original_report/info');
export const dataSearchComprehensive = getActuralApi('/app/v1/data_search/comprehensive_search');
export const dataSearchConfig = getActuralApi('/app/v1/data_search/module_config');
export const dataSearchSorted = getActuralApi('/app/v1/data_search/comprehensive_search/sorted');
export const dataSearchProduct = getActuralApi('/app/v1/search/group_product_invest_org/summary');
// 搜索记录、浏览记录
export const searchHistory = `/jstore/visitlog/classified/list`;
// 炒股工具箱搜索
export const stockSearchQuery = `/open/app/v1/stock_search/query`;
// 炒股工具箱上市记录
export const stockSearchHistory = `/open/app/v1/stock_search/visit_log`;
// 人物相关资讯
export const newsSearch = '/open/person_info/v1/info/news';
